/* eslint-disable no-undef */
import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getAiSummaryList = async (
  token,
  page = null,
  per_page = null,
  filter = {}
) => {
  const params = new URLSearchParams({ page, per_page });
  if (filter.patient_id) params.append("patient_id", filter.patient_id);
  if (filter.resource_id) params.append("resource_id", filter.resource_id);
  if (filter.resource_type) params.append("resource_type", filter.resource_type);
  if (filter.summary_type) params.append("summary_type", filter.summary_type);

  const endpoint = `/api/v1/admin/ai_summaries?${params.toString()}`;

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
